import { Controller } from 'stimulus'

const NUMERIC = ['number', 'float']

export default class extends Controller {
  static targets = ['body', 'input', 'addButton', 'totals', 'count']

  connect() {
    this.config   = JSON.parse(this.data.get('config'))
    this.labels   = JSON.parse(this.data.get('labels'))
    this.disabled = this.data.get('disabled') === 'true'
    this.rows     = JSON.parse(this.inputTarget.value || '[]')

    const minRows = this.config.min_rows || 0
    while (this.rows.length < minRows) { this.rows.push({}) }
    this.render()
  }

  add(event) {
    event.preventDefault()
    if (this.rows.length >= this.config.max_rows) { return }

    this.rows.push({})
    this.render()
    const firstCell = this.bodyTarget.querySelector('tr:last-child .bp-cell')
    if (firstCell) { firstCell.focus() }
  }

  remove(event) {
    event.preventDefault()
    this.rows.splice(parseInt(event.currentTarget.dataset.index, 10), 1)
    this.render()
  }

  change(event) {
    const { index, key, type } = event.target.dataset
    const row   = this.rows[parseInt(index, 10)]
    const value = event.target.value

    if (value === '') {
      delete row[key]
    } else if (type === 'yes_no') {
      row[key] = value === 'true'
    } else if (NUMERIC.includes(type)) {
      row[key] = Number(value)
    } else {
      row[key] = value
    }
    this.sync()
  }

  render() {
    this.bodyTarget.innerHTML = ''
    this.rows.forEach((row, index) => this.bodyTarget.appendChild(this.renderRow(row, index)))
    this.sync()
  }

  renderRow(row, index) {
    const tr = document.createElement('tr')

    const number = document.createElement('td')
    number.className = 'bp-index'
    number.textContent = index + 1
    tr.appendChild(number)

    this.config.columns.forEach((column) => {
      const td = document.createElement('td')
      td.appendChild(this.renderInput(column, row[column.key], index))
      tr.appendChild(td)
    })

    const actions = document.createElement('td')
    actions.className = 'bp-actions'
    if (!this.disabled && this.rows.length > (this.config.min_rows || 0)) {
      const button = document.createElement('a')
      button.href = '#'
      button.className = 'bp-remove'
      button.title = this.labels.remove
      button.innerHTML = '<i class="fas fa-trash"></i>'
      button.dataset.index  = index
      button.dataset.action = 'click->blueprints--table-answer#remove'
      actions.appendChild(button)
    }
    tr.appendChild(actions)
    return tr
  }

  renderInput(column, value, index) {
    let input
    if (column.type === 'select' || column.type === 'yes_no') {
      input = document.createElement('select')
      const options = column.type === 'yes_no'
        ? [['true', this.labels.yes], ['false', this.labels.no]]
        : column.options.map((option) => [option, option])
      input.appendChild(new Option('', ''))
      options.forEach(([optionValue, label]) => input.appendChild(new Option(label, optionValue)))
      input.value = value === undefined || value === null ? '' : String(value)
    } else {
      input = document.createElement('input')
      input.type = { number: 'number', float: 'number', date: 'date' }[column.type] || 'text'
      if (column.type === 'float') { input.step = 'any' }
      if (column.type === 'number') { input.step = '1' }
      input.value = value === undefined || value === null ? '' : value
    }
    input.className = `bp-cell${NUMERIC.includes(column.type) ? ' bp-num' : ''}`
    input.disabled  = this.disabled
    input.setAttribute('aria-label', column.name)
    input.dataset.index  = index
    input.dataset.key    = column.key
    input.dataset.type   = column.type
    input.dataset.action = 'change->blueprints--table-answer#change'
    return input
  }

  sync() {
    const filled = this.rows.filter((row) => Object.keys(row).length > 0)
    const value = filled.length > 0 ? JSON.stringify(filled) : ''
    // Lines added or removed by a click: the conditions hear it as a change
    if (this.inputTarget.value !== value) {
      this.inputTarget.value = value
      this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
    }

    this.totalsTargets.forEach((cell) => {
      const key   = cell.dataset.key
      const total = filled.reduce((sum, row) => sum + (Number(row[key]) || 0), 0)
      cell.textContent = Math.round(total * 100) / 100
    })

    const full = this.rows.length >= this.config.max_rows
    this.addButtonTarget.classList.toggle('d-none', this.disabled || full)
    this.countTarget.textContent = this.labels.lines
      .replace('%{count}', this.rows.length)
      .replace('%{max}', this.config.max_rows)
  }
}
